import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';

import { ReplaceInPersonFormState, StepMap } from '../../../../../constants';
import { ReplaceInPersonFormActionMap } from '../../../../../reducer';

import { ButtonImageInput } from '@/components/atoms/Button';
import { useFormContext } from '@/components/forms/FormContext';
import { ImageStepExamples } from '../ImageStepExamples';
import { HeadingText } from '@/components/atoms/HeadingText';
import { HeadingDescription } from '@/components/atoms/HeadingDescription';
import { TextLink } from '@/components/TextLink';

interface DesktopUploadsProps {
	testId?: string;
	handleAddImage: (event: ChangeEvent<HTMLInputElement>) => void;
	setShowQR: Dispatch<SetStateAction<boolean>>;
	setShowUpload: Dispatch<SetStateAction<boolean>>;
}

const DesktopUpload = (props: DesktopUploadsProps) => {
	const {
		testId = 'DesktopUpload',
		handleAddImage,
		setShowQR,
		setShowUpload,
	} = props;
	const { state } = useFormContext<
		StepMap,
		ReplaceInPersonFormState,
		ReplaceInPersonFormActionMap
	>();

	function changeToQR() {
		setShowQR(true);
		setShowUpload(false);
	}

	return (
		<div data-testid={testId}>
			<HeadingText tag="h1" size="h3" className="mb-4" balanced>
				<span className="hidden lg:block">
					Upload a photo of your outdoor HVAC label
				</span>
				<span className="block lg:hidden">
					Take or upload a photo of your outdoor HVAC label
				</span>
			</HeadingText>

			<HeadingDescription className="text-xl !text-black lg:!text-2xl">
				Take a look at these examples to help find the label on your outdoor
				unit.
			</HeadingDescription>

			<ImageStepExamples />

			<div className="lg:mb-6">
				<ButtonImageInput
					name="files"
					variant={
						state.pictures.length > 0 ? 'large-outline' : 'large-default'
					}
					className="mx-auto w-full max-w-101"
					onChange={handleAddImage}
				>
					<span className="hidden lg:block">
						{state.pictures.length > 0
							? 'Upload another photo'
							: 'Upload a photo'}
					</span>
					<span className="block lg:hidden">
						{state.pictures.length > 0
							? 'Take or upload another photo'
							: 'Take or upload a photo'}
					</span>
				</ButtonImageInput>
			</div>
			<div className="hidden justify-center lg:flex">
				<TextLink onClick={changeToQR}>Take photo with phone</TextLink>
			</div>
		</div>
	);
};

export default DesktopUpload;
